module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/component-indexof/index.js
 ** module id = 167
 ** module chunks = 0
 **/